// extracted by mini-css-extract-plugin
module.exports = {"overlay":"dd31006766--overlay--XGqSv","loader":"dd31006766--loader--ENCNK","centered":"dd31006766--centered--B65iB"};